export default "__VITE_ASSET__cBftORic__"